import { EntityImportValidationError } from "@idw-types/data/entity-import-validation-error";

const generateInvalidIdMessage = (error: EntityImportValidationError) => {
    let errorMessage = "";

    if (error.objectType && error.objectID) {
        errorMessage += `${error.objectType} with ID ${error.objectID} `;

        if (error.fieldType && error.fieldID) {
            errorMessage += `references ${error.fieldType} with ID ${error.fieldID} that does not exist.`;
        } else {
            errorMessage += `does not exist.`;
        }
    }

    return errorMessage;
};

const generateNameMismatchMessage = (error: EntityImportValidationError) => {
    let errorMessage = "";

    if (error.objectType && error.objectID) {
        errorMessage += `${error.objectType} with ID ${error.objectID} `;

        if (error.fieldType && error.fieldID && error.fieldName) {
            errorMessage += `references ${error.fieldType} with ID ${error.fieldID} and name "${error.fieldName}". `;

            errorMessage += `This name does not match the existing ${error.fieldType} name of "${error.localFieldName}."`;
        }
    }

    return errorMessage;
};

const generateLabelMismatchMessage = (error: EntityImportValidationError) => {
    let errorMessage = "";

    if (error.objectType && error.objectID) {
        errorMessage += `${error.objectType} with ID ${error.objectID} `;

        if (error.fieldType && error.fieldID) {
            errorMessage += `has ${error.fieldType} with ID ${error.fieldID} and value ${error.fieldName}. `;

            errorMessage += `This value does not match the existing ${error.fieldType} value of ${error.localFieldName}.`
        }
    }

    return errorMessage;
};

const generateOtherMessage = (error: EntityImportValidationError) => {
    return error.errorMessage;
};

export const generateImportErrorMessages = (errors: Array<EntityImportValidationError>) => {
    const errorStrings: Array<string> = [];

    errors.forEach(error => {
        switch (error.errorType) {
            case "INVALID_ID":
                errorStrings.push(generateInvalidIdMessage(error));
                break;
            case "NAME_MISMATCH":
                errorStrings.push(generateNameMismatchMessage(error));
                break;
            case "LABEL_MISMATCH":
                errorStrings.push(generateLabelMismatchMessage(error));
                break;
            case "OTHER":
                errorStrings.push(generateOtherMessage(error));
                break;
            default:
                break;
        }
    });

    return errorStrings;
};
